import {
  Slate,
  Editable,
  withReact,
  useSlateStatic,
  useReadOnly,
  ReactEditor,
} from 'slate-react'

import {
  Editor,
  Transforms,
  Range,
  Point,
  createEditor,
  Element as SlateElement,
} from 'slate'
import { css } from '@emotion/css'

import Placeholder from '../elements/placeholder';

import { getStyles } from 'generics/components/basic-text-editor-slate/utilities';

export const CheckListItemElement = (props) => {

  const { attributes, children, element } = props;
  const editor = useSlateStatic()
  const readOnly = useReadOnly()
  const { checked } = element

  const elementAttributes = {
    ...attributes,
    style: getStyles(element),
    className: `editor-checkbox-list-item ${css`
          display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: flex-start;
  gap: 5px;
        & + & {
          margin-top: 0;
        }
      `}`
  };

  return (
    <div {...elementAttributes}>
      <span
        contentEditable={false}
        className={css`
          margin-top: 1px;
        `}
      >
        <input
          type="checkbox"
          checked={checked}
          onMouseDown={event => {
            event.preventDefault()
          }}
          onChange={event => {
            const path = ReactEditor.findPath(editor, element)
            const newProperties = {
              checked: event.target.checked,
            }
            Transforms.setNodes(editor, newProperties, { at: path })
          }}
        />
      </span>
      <span
        contentEditable={!readOnly}
        suppressContentEditableWarning
        className={css`
          flex: 1;
          opacity: ${checked ? 0.666 : 1};
          text-decoration: ${!checked ? 'none' : 'line-through'};
          &:focus {
            outline: none;
          }
        `}
      >
        {<Placeholder element={props.element} placeholder={props.placeholder} />}
        {children}
      </span>
    </div>
  )
}